import { render } from "./DomesticPoster.vue?vue&type=template&id=c5d828c2&ts=true"
import script from "./DomesticPoster.vue?vue&type=script&lang=ts"
export * from "./DomesticPoster.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__